export const SET_POST = 'SET_POST';
